module.exports = __webpack_public_path__ + "img/Rectangle-1.57fd0320.png";